module.exports = __webpack_public_path__ + "img/section-meter-electricity-meter-analog-lg.9d458ee7.svg";